import cn from 'clsx';
import CategoryLink from './CategoryLink';
import { SpecialDealLink } from '@v2/brands/discountmags/Layouts/Full/Navigation';
import { DesktopMenuPopover, DesktopMenuLink } from '.';
import { type Category, type MenuItem } from '@v2/shared/lib/types';
import { useSite } from '@v2/shared/lib/site';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = {
  categories: Category[];
  booksCategories?: Category[];
  className?: string;
  specialDealLinks: MenuItem[];
};

export default function DesktopCategoryBar({
  categories,
  className,
  specialDealLinks,
  booksCategories,
}: Props) {
  const { buildUrl } = useUrlGenerator();
  // Gifts & More is one page, so it is a link rather than a menu. US-only, on the same
  // terms as the footer's: RoutesBuilder registers the page for DiscountMags US alone.
  const { country } = useSite();

  return (
    <div className={cn('flex items-center justify-center gap-2', className)}>
      <DesktopMenuPopover title="All Categories">
        <div className="columns-2 md:columns-3 xl:columns-4 px-8 pb-6 pt-4">
          {categories.map((category) => {
            return <CategoryLink key={category.id} category={category} />;
          })}
        </div>
      </DesktopMenuPopover>
      <DesktopMenuPopover title="Special Deals">
        <div className="w-full">
          <div className="grid md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-4 py-8 px-10">
            {specialDealLinks.map(({ id, href, title, icon, priceIcon }) => (
              <SpecialDealLink key={id} href={href} title={title} icon={icon} priceIcon={priceIcon} />
            ))}
          </div>
        </div>
      </DesktopMenuPopover>
      <DesktopMenuLink href={buildUrl('/bestsellers')} ariaLabel="Shop Best Sellers">
        Best Sellers
      </DesktopMenuLink>
      {booksCategories && (
        <DesktopMenuPopover title="Books" className="relative" href={buildUrl(`/categories/books`)}>
          <div className="columns-2 md:columns-3 xl:columns-4 px-8 pb-6 pt-4">
            {booksCategories.map((category) => {
              return <CategoryLink key={category.id} category={category} />;
            })}
          </div>
        </DesktopMenuPopover>
      )}
      {country === 'US' && <DesktopMenuLink href={buildUrl('/categories/gifts')}>Gifts &amp; More</DesktopMenuLink>}
    </div>
  );
}
